export enum HildaStatus {
  Funded = '1',
  NotFunded = '2',
  Pending = '3',
}
